import FalconCloseButton from '@/components/common/FalconCloseButton';
import { ReactNode, useState } from 'react';
import { Modal } from '@/components/common/AppModal';
import { Button, Spinner } from 'react-bootstrap';

type ConfirmActionModalProps = {
  show: boolean;
  onClose?: () => void;
  title: ReactNode;
  description?: ReactNode;
  confirmText?: ReactNode;
  cancelText?: ReactNode;
  confirmVariant?: string;
  onConfirm?: () => void | Promise<void>;
  isConfirming?: boolean;
  closeOnConfirm?: boolean;
  backdrop?: true | false | 'static';
  keyboard?: boolean;
  buttonSize?: 'sm' | 'lg';
};

const ConfirmActionModal = ({
  show,
  onClose,
  title,
  description,
  confirmText = 'تایید',
  cancelText = 'انصراف',
  confirmVariant = 'danger',
  onConfirm,
  isConfirming = false,
  closeOnConfirm = true,
  backdrop = 'static',
  keyboard = false,
  buttonSize
}: ConfirmActionModalProps) => {
  const [isLocalSubmitting, setIsLocalSubmitting] = useState(false);
  const loading = isConfirming || isLocalSubmitting;

  const handleConfirm = async () => {
    if (!onConfirm || loading) return;
    try {
      setIsLocalSubmitting(true);
      await onConfirm();
      if (closeOnConfirm) {
        onClose?.();
      }
    } finally {
      setIsLocalSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} backdrop={backdrop} keyboard={keyboard}>
      <Modal.Header>
        <Modal.Title className="fs-0">{title}</Modal.Title>
        <FalconCloseButton
          onClick={onClose}
          size={undefined}
          noOutline={false}
          variant={undefined}
          className={undefined}
        />
      </Modal.Header>
      <Modal.Body className="fs--1">{description}</Modal.Body>
      <Modal.Footer>
        <Button
          size={buttonSize}
          variant="secondary"
          onClick={onClose}
          disabled={loading}
        >
          {cancelText}
        </Button>
        <Button
          size={buttonSize}
          variant={confirmVariant}
          onClick={handleConfirm}
          disabled={loading}
          className="d-inline-flex align-items-center justify-content-center gap-1"
        >
          {loading ? (
            <>
              <Spinner
                animation="border"
                size="sm"
                className="flex-shrink-0"
                style={{ width: '0.85em', height: '0.85em', borderWidth: '0.14em' }}
              />
              در حال انجام...
            </>
          ) : (
            confirmText
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmActionModal;
